<p><i class="fas fa-camera mr-1"></i>This is coming from the captcha component</p>
